import PropTypes from 'prop-types';

export const getEstimatedMonthlyBudgetStyles = () => {
  const budgetMonthly = {
    marginTop: '16px',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
  };

  return {
    budgetMonthly,
  };
};

export const classesProps = PropTypes.shape({
  budgetMonthly: PropTypes.string,
});
